import SiteHeader from "@/components/common/SiteHeader";
import { createFileRoute } from "@tanstack/react-router";
import Dashboard from "@/pages/Dashboard/Page";
import React from "react";

const Index = () => (
  <div className="flex flex-col w-full bg-background">
    {/* Dashboard page renders its own <h1>Dashboard</h1> + subtitle.
        Don't pass `header=` here — would render the title twice. */}
    <SiteHeader />
    <Dashboard />
  </div>
);
export const Route = createFileRoute("/")({
  component: Index,
});
